import { createFileRoute } from '@tanstack/react-router'
import { Site } from 'pages/site/Site'
import { siteSearchParams } from 'routes/organization_/site/-searchParams'

const RouteComponent = () => {
  const { mode, orgId, siteId } = Route.useSearch()

  return (
    <Site
      key={`site-${mode}-${orgId}-${siteId ?? 'new'}`}
      mode={mode}
      orgID={orgId}
      siteID={siteId}
    />
  )
}

export const Route = createFileRoute('/organization_/site/')({
  component: RouteComponent,
  validateSearch: siteSearchParams,
  staticData: {
    title: 'Site',
    layout: {
      enableScrolling: true,
    },
  },
  beforeLoad: ({ search }) => {
    if (search.mode === 'edit' && !search.siteId) {
      throw new Error(
        'Edit mode requires site ID. Use /organization/site?mode=edit&orgId={orgId}&siteId={siteId}'
      )
    }
  },
})
